import { render, staticRenderFns } from "./RoutingDetail.vue?vue&type=template&id=270ae3dc"
import script from "./RoutingDetail.vue?vue&type=script&lang=js"
export * from "./RoutingDetail.vue?vue&type=script&lang=js"
import style0 from "./RoutingDetail.vue?vue&type=style&index=0&id=270ae3dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports